"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phiDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var phiDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createPhi: _factoriesAny.createPhi
};
exports.phiDependencies = phiDependencies;